<template>
  <Card class="mt-16 py-24 box-shadow-none !bg-transparent sm:box-shadow-sm sm:bg-white">
    <div>
      <div class="flex justify-between">
        <h2 class="text-h2">Pet {{ petIndex + 1 }}</h2>
        <button v-if="petCount > 1" class="text-grey-clickable underline" @click="$emit('remove-pet', petIndex)">
          Remove pet
        </button>
      </div>
    </div>
  </Card>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';

export default {
  name: 'PetDetailsForm',
  components: { Card },
  props: {
    petData: {
      type: Object,
      required: true,
    },
    petIndex: {
      type: Number,
      required: true,
    },
    petCount: {
      type: Number,
      required: true,
    },
  },
};
</script>
